import { render, staticRenderFns } from "./KA1Log.vue?vue&type=template&id=64b6b220&scoped=true"
import script from "./KA1Log.vue?vue&type=script&lang=js"
export * from "./KA1Log.vue?vue&type=script&lang=js"
import style0 from "./KA1Log.vue?vue&type=style&index=0&id=64b6b220&prod&lang=css"
import style1 from "./KA1Log.vue?vue&type=style&index=1&id=64b6b220&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64b6b220",
  null
  
)

export default component.exports